module.exports = __webpack_public_path__ + "img/qzpj.6851ae90.jpg";